import { render } from "./cn.vue?vue&type=template&id=16a0f9fa&scoped=true"
import script from "./cn.vue?vue&type=script&lang=js"
export * from "./cn.vue?vue&type=script&lang=js"

import "./cn.vue?vue&type=style&index=0&id=16a0f9fa&scoped=true&lang=css"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a0f9fa"]])

export default __exports__